import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const featuredPosts = [
  {
    id: 1,
    slug: "5-things-before-roofing",
    category: "Roofing · Homeowners",
    title: "5 things to do before you start a roofing project",
    summary:
      "Quick checks you can do before signing a roofing contract: photos, insurance, written scope of work, permits, and cleanup details.",
    readTime: "4 min read",
  },
  {
    id: 2,
    slug: "is-your-roof-ready-for-solar",
    category: "Solar · Roof Prep",
    title: "Is your roof ready for solar panels?",
    summary:
      "Why many homeowners replace or tune-up their roof before going solar, and how to avoid surprise costs after the panels are installed.",
    readTime: "3 min read",
  },
  {
    id: 3,
    slug: "small-curb-appeal-upgrades",
    category: "Landscaping · Curb Appeal",
    title: "Small curb-appeal upgrades that make a big difference",
    summary:
      "Simple projects like clean edges, fresh mulch, and lighting can help your home stand out without a full landscaping overhaul.",
    readTime: "3 min read",
  },
  {
    id: 4,
    slug: "roofing-contractor-los-angeles",
    category: "Roofing",
    title: "How to Find a Trusted Roofing Contractor in California",
    summary:
      "What to look for when hiring a roofing contractor in California — licensing, red flags, pricing, and how to avoid getting burned.",
    readTime: "5 min read",
  },
  {
    id: 5,
    slug: "solar-panel-installation-cost-california-2026",
    category: "Solar",
    title: "Solar Panel Installation Cost in California: 2026 Guide",
    summary:
      "A clear breakdown of what solar panels actually cost in California in 2026, including tax credits, installer quotes, and what to watch out for.",
    readTime: "6 min read",
  },
  {
    id: 6,
    slug: "landscaping-contractor-los-angeles",
    category: "Landscaping",
    title: "Best Landscaping Services in California: What to Look For",
    summary:
      "How to hire a landscaping contractor in California without overpaying — from drought-tolerant design to irrigation systems and what the good ones always include.",
    readTime: "5 min read",
  },
  {
    id: 7,
    slug: "hvac-repair-cost-california",
    category: "HVAC",
    title: "How Much Does HVAC Repair Cost in California?",
    summary:
      "Real HVAC repair cost ranges in California for 2026, common issues, what drives the price, and how to find a reliable HVAC contractor without overpaying.",
    readTime: "5 min read",
  },
  {
    id: 8,
    slug: "plumber-los-angeles",
    category: "Plumbing",
    title: "How to Find a Plumber in California Fast",
    summary:
      "Need a plumber in California fast? Here's exactly how to find one that's licensed, priced fairly, and available — without getting ripped off in an emergency.",
    readTime: "5 min read",
  },
  {
    id: 9,
    slug: "roofing-contractor-pasadena",
    category: "Roofing · Pasadena",
    title: "How to Hire a Roofing Contractor in Pasadena, CA",
    summary:
      "What Pasadena homeowners need to know before starting a roofing project — fire ratings, Craftsman-era considerations, licensing, and how to prepare project details.",
    readTime: "6 min read",
  },
  {
    id: 10,
    slug: "landscaping-services-long-beach",
    category: "Landscaping · Long Beach",
    title: "Landscaping Services in Long Beach, California: What to Expect",
    summary:
      "From drought-tolerant design to turf rebates, here's how Long Beach homeowners can find landscaping services that deliver real value.",
    readTime: "6 min read",
  },
  {
    id: 11,
    slug: "solar-installation-glendale",
    category: "Solar · Glendale",
    title: "Solar Installation in Glendale, CA: What You Need to Know Before You Sign",
    summary:
      "Glendale Water & Power net metering, permit timelines, costs, and how to pick a solar installer with real GWP experience.",
    readTime: "6 min read",
  },
  {
    id: 12,
    slug: "hvac-repair-santa-monica",
    category: "HVAC · Santa Monica",
    title: "HVAC Repair in Santa Monica, California: Costs and How to Hire Right",
    summary:
      "Coastal air, heat pump options, and premium labor rates — what Santa Monica homeowners should know before calling an HVAC contractor.",
    readTime: "6 min read",
  },
  {
    id: 13,
    slug: "plumber-burbank",
    category: "Plumbing · Burbank",
    title: "How to Find a Plumber in Burbank, CA — Fast and Without Getting Overcharged",
    summary:
      "From slab leaks to emergency shutoffs — what Burbank homeowners need to know to hire a licensed plumber quickly and confidently.",
    readTime: "5 min read",
  },
  {
    id: 14,
    slug: "plumber-pasadena",
    category: "Plumbing · Pasadena",
    title: "How to Find a Reliable Plumber in Pasadena, CA",
    summary:
      "Pasadena's older homes mean older pipes. Here's how to find a licensed plumber in Pasadena who knows local codes, gives fair quotes, and shows up when they say they will.",
    readTime: "5 min read",
  },
  {
    id: 15,
    slug: "roofing-contractor-long-beach",
    category: "Roofing · Long Beach",
    title: "How to Hire a Roofing Contractor in Long Beach, CA",
    summary:
      "Salt air, marine layer, and aging bungalows — Long Beach roofing has its own set of challenges. Here's what to know before you hire a roofer.",
    readTime: "6 min read",
  },
  {
    id: 16,
    slug: "electrician-los-angeles",
    category: "Electrical",
    title: "How to Find a Licensed Electrician in California",
    summary:
      "Electrical work in LA requires licensed contractors and permits. Here's how to hire the right electrician, avoid overcharges, and keep your home safe.",
    readTime: "5 min read",
  },
  {
    id: 17,
    slug: "landscaping-glendale",
    category: "Landscaping · Glendale",
    title: "Landscaping Services in Glendale, CA: What to Expect",
    summary:
      "From drought-tolerant redesigns to hillside drainage — here's how Glendale homeowners can find the right landscaping contractor without overpaying.",
    readTime: "5 min read",
  },
  {
    id: 18,
    slug: "solar-panels-long-beach",
    category: "Solar · Long Beach",
    title: "Solar Panels in Long Beach, CA: Costs, Incentives, and What to Know Before You Sign",
    summary:
      "Long Beach gets over 280 sunny days a year and strong SCE net metering. Here's what solar panels actually cost and how to hire the right installer.",
    readTime: "6 min read",
  },
  {
    id: 19,
    slug: "hvac-contractor-burbank",
    category: "HVAC · Burbank",
    title: "How to Find a Reliable HVAC Contractor in Burbank, CA",
    summary:
      "Burbank summers are brutal. Here's how to hire a licensed HVAC contractor who shows up, prices fairly, and keeps your system running through the heat.",
    readTime: "5 min read",
  },
  {
    id: 20,
    slug: "roofing-contractor-santa-monica",
    category: "Roofing · Santa Monica",
    title: "How to Hire a Roofing Contractor in Santa Monica, CA",
    summary:
      "Santa Monica's coastal climate, historic homes, and strict permit requirements make roofing more complex than most cities. Here's what to know before you hire.",
    readTime: "6 min read",
  },
  {
    id: 21,
    slug: "electrician-pasadena",
    category: "Electrical · Pasadena",
    title: "How to Find a Licensed Electrician in Pasadena, CA",
    summary:
      "Pasadena's older homes often mean outdated panels and knob-and-tube wiring. Here's how to hire a licensed electrician who handles the job safely and by the book.",
    readTime: "5 min read",
  },
  {
    id: 22,
    slug: "plumber-glendale",
    category: "Plumbing · Glendale",
    title: "How to Find a Plumber in Glendale, CA — Fast and Without Getting Overcharged",
    summary:
      "From slab leaks to water heater replacements, here's how Glendale homeowners can hire a licensed plumber quickly and confidently.",
    readTime: "5 min read",
  },
  {
    id: 23,
    slug: "landscaping-burbank",
    category: "Landscaping · Burbank",
    title: "Landscaping Services in Burbank, CA: How to Hire Right and Save on Water",
    summary:
      "Burbank's hot summers and BWP rebates make drought-tolerant landscaping both practical and affordable. Here's how to hire a great landscaping contractor.",
    readTime: "5 min read",
  },
  {
    id: 24,
    slug: "roofing-contractor-torrance",
    category: "Roofing · Torrance",
    title: "How to Hire a Roofing Contractor in Torrance, CA",
    summary:
      "What Torrance homeowners need to know before starting a roofing project — licensing, coastal climate considerations, permits, and how to prepare project details.",
    readTime: "5 min read",
  },
  {
    id: 25,
    slug: "solar-installation-inglewood",
    category: "Solar · Inglewood",
    title: "Solar Panel Installation in Inglewood, CA — What Homeowners Need to Know",
    summary:
      "How Inglewood homeowners can go solar, what it costs, how to find a licensed installer, and what to watch out for before signing anything.",
    readTime: "5 min read",
  },
  {
    id: 26,
    slug: "landscaping-contractor-torrance",
    category: "Landscaping · Torrance",
    title: "Finding a Reliable Landscaping Contractor in Torrance, CA",
    summary:
      "What Torrance homeowners should know before hiring a landscaping contractor — drought-tolerant plants, water restrictions, licensing, and what a good quote looks like.",
    readTime: "4 min read",
  },
  {
    id: 27,
    slug: "electrician-inglewood",
    category: "Electrical · Inglewood",
    title: "How to Find a Licensed Electrician in Inglewood, CA",
    summary:
      "What Inglewood homeowners need to know before hiring an electrician — licensing, panel upgrades, EV chargers, permits, and how to avoid common scams.",
    readTime: "4 min read",
  },
  {
    id: 28,
    slug: "roofing-contractor-redondo-beach",
    category: "Roofing · Redondo Beach",
    title: "How to Hire a Roofing Contractor in Redondo Beach, CA",
    summary:
      "What Redondo Beach homeowners need to know before hiring a roofing contractor — coastal climate, salt air, licensing, permits, and getting the best quotes.",
    readTime: "5 min read",
  },
  {
    id: 29,
    slug: "roofing-contractor-manhattan-beach",
    category: "Roofing · Manhattan Beach",
    title: "How to Hire a Roofing Contractor in Manhattan Beach, CA",
    summary:
      "What Manhattan Beach homeowners need to know before hiring a roofing contractor — coastal durability, licensing, permits, and finding the right contractor for high-value homes.",
    readTime: "5 min read",
  },
  {
    id: 30,
    slug: "solar-installation-arcadia",
    category: "Solar · Arcadia",
    title: "Solar Panel Installation in Arcadia, CA — What Homeowners Need to Know",
    summary:
      "How Arcadia homeowners can go solar, understand local incentives, find a licensed installer, and avoid common mistakes before signing.",
    readTime: "5 min read",
  },
  {
    id: 31,
    slug: "plumber-torrance",
    category: "Plumbing · Torrance",
    title: "How to Find a Licensed Plumber in Torrance, CA",
    summary:
      "What Torrance homeowners need to know before hiring a plumber — licensing, common repairs, water heaters, slab leaks, and how to get a fair quote.",
    readTime: "4 min read",
  },
  {
    id: 32,
    slug: "electrician-long-beach",
    category: "Electrical · Long Beach",
    title: "How to Find a Licensed Electrician in Long Beach, CA",
    summary:
      "What Long Beach homeowners need to know before hiring an electrician — panel upgrades, EV chargers, licensing, permits, and avoiding common problems.",
    readTime: "4 min read",
  },
  {
    id: 33,
    slug: "hvac-contractor-pasadena",
    category: "HVAC · Pasadena",
    title: "How to Find a Reliable HVAC Contractor in Pasadena, CA",
    summary:
      "What Pasadena homeowners need to know about HVAC repair, replacement, and installation — licensing, costs, what to ask, and how to get fair quotes.",
    readTime: "5 min read",
  },
  {
    id: 34,
    slug: "roofing-contractor-long-beach",
    category: "Roofing · Long Beach",
    title: "Finding a Trusted Roofing Contractor in Long Beach, CA",
    summary: "If you need roofing services in Long Beach, CA, finding a reliable contractor is essential. Here's what to look for.",
    readTime: "4 min read",
  },
  {
    id: 35,
    slug: "hvac-repair-san-fernando-valley",
    category: "HVAC · San Fernando Valley",
    title: "Expert HVAC Repair in the San Fernando Valley",
    summary: "Facing HVAC issues in the San Fernando Valley? Find out how to get reliable repair services to keep your home comfortable.",
    readTime: "4 min read",
  },
  {
    id: 36,
    slug: "kitchen-remodel-pasadena",
    category: "Remodeling · Pasadena",
    title: "Transform Your Home with a Kitchen Remodel in Pasadena, CA",
    summary: "Considering a kitchen remodel in Pasadena, CA? Learn how to plan your project and find the right contractors.",
    readTime: "4 min read",
  },
  {
    id: 37,
    slug: "solar-panels-torrance",
    category: "Solar · Torrance",
    title: "Go Green with Solar Panel Installation in Torrance, CA",
    summary: "Considering solar panels for your Torrance home? Learn about the benefits and how to find expert installers.",
    readTime: "4 min read",
  },
  {
    id: 38,
    slug: "plumbing-glendale",
    category: "Plumbing · Glendale",
    title: "Reliable Plumbing Contractor Services in Glendale, CA",
    summary: "Need a plumbing contractor in Glendale, CA? Learn how to find reliable and licensed professionals for your home or business.",
    readTime: "4 min read",
    slug: "hvac-repair-san-fernando-valley",
    category: "HVAC · San Fernando Valley",
    title: "How to Find HVAC Repair in the San Fernando Valley",
    summary:
      "Valley summers hit 100°+. When your AC goes out, you need fast help. How to find a reliable HVAC contractor in the SFV without getting burned.",
    readTime: "5 min read",
  },
  {
    id: 35,
    slug: "kitchen-remodel-pasadena",
    category: "Remodeling · Pasadena",
    title: "Kitchen Remodel in Pasadena, CA: What to Know Before You Start",
    summary:
      "Pasadena has some of the most beautiful Craftsman and mid-century homes in LA. How to remodel your kitchen without losing the character — or your budget.",
    readTime: "6 min read",
  },
  {
    id: 36,
    slug: "solar-panels-torrance",
    category: "Solar · Torrance",
    title: "Solar Panel Installation in Torrance, CA: A Homeowner's Guide",
    summary:
      "Torrance gets 280+ sunny days a year. How to go solar without overpaying — tax credits, roof prep, local installers, and what your neighbors wish they knew.",
    readTime: "6 min read",
  },
  {
    id: 37,
    slug: "plumbing-glendale",
    category: "Plumbing · Glendale",
    title: "Finding a Plumbing Contractor in Glendale, CA",
    summary:
      "From 1920s-era galvanized pipes to hillside drainage challenges, Glendale plumbing has its own issues. How to find the right plumber for the job.",
    readTime: "5 min read",
  },
];

export default function BlogIndex() {
  // 🔹 Basic SEO for the blog home
  useEffect(() => {
    const title = "BuildBright Blog – Home Improvement Tips & Guides";
    const description =
      "Short, practical guides on roofing, solar, and landscaping so you know what to expect before you request quotes or sign a contract.";

    document.title = title;

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description);
  }, []);

  return (
    <main className="min-h-screen bg-black text-slate-50">
      <div className="max-w-5xl mx-auto px-4 py-12">
        {/* Hero */}
        <header className="mb-10">
          <p className="text-xs font-semibold tracking-[0.2em] text-amber-400 mb-2">
            OUR BLOG
          </p>
          <h1 className="text-3xl sm:text-4xl font-bold mb-3 text-slate-50">
            Expert tips for smoother home projects.
          </h1>
          <p className="text-sm sm:text-base text-slate-300 max-w-2xl">
            Short, practical guides on roofing, solar, landscaping, HVAC, and plumbing so you
            know what to expect before you request quotes or sign a contract.
          </p>
        </header>

        {/* Posts grid */}
        <section className="grid gap-6 md:grid-cols-3 mb-12">
          {featuredPosts.map((post) => (
            <Link
              key={post.id}
              to={`/blog/${post.slug}`}
              className="flex flex-col rounded-2xl border border-slate-800 bg-black/80 p-5 shadow-lg hover:shadow-xl transition-shadow focus:outline-none focus:ring-2 focus:ring-amber-400"
            >
              <p className="text-xs font-semibold uppercase tracking-wide text-orange-300 mb-2">
                {post.category}
              </p>
              <h2 className="text-base font-semibold mb-2 text-slate-50">
                {post.title}
              </h2>
              <p className="text-sm text-slate-300 flex-1 mb-3">
                {post.summary}
              </p>
              <div className="flex items-center justify-between text-xs text-slate-400">
                <span>{post.readTime}</span>
                <span className="font-semibold text-amber-300">
                  Read article →
                </span>
              </div>
            </Link>
          ))}
        </section>

        {/* Disclaimer */}
        <section className="mb-12">
          <p className="text-sm text-slate-400">
            These topics are for general information only and are not a
            substitute for advice from a licensed contractor or professional.
          </p>
        </section>

        {/* Newsletter / stay updated */}
        <section className="rounded-2xl bg-black border border-slate-800 px-6 py-8 mt-4">
          <h2 className="text-xl font-semibold mb-2 text-slate-50">
            Stay updated
          </h2>
          <p className="text-sm text-slate-300 mb-4 max-w-xl">
            When we publish new guides on roofing, solar, or landscaping, we&apos;ll
            send occasional updates. No spam, ever.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 max-w-md">
            <input
              type="email"
              placeholder="Email signup coming soon"
              className="flex-1 rounded-md border border-slate-700 bg-black px-3 py-2 text-sm text-slate-200"
              disabled
            />
            <button
              type="button"
              className="rounded-md bg-amber-400 px-4 py-2 text-sm font-semibold text-slate-950 opacity-70 cursor-not-allowed"
            >
              Subscribe (coming soon)
            </button>
          </div>
        </section>
      </div>
    </main>
  );
}
